<ng-container [formGroup]="form">
  <nz-form-item>
    <nz-form-label [nzRequired]="isRequired">
      <p class="form-desc">
        After the student engages in the behavior, what kind of consequences
        does it commonly have? Select all that apply.
      </p>
    </nz-form-label>
    <div class="checkbox-wrapper">
      <span
        *ngFor="let con of behaviorConsequenceList; trackBy: trackById"
        nz-checkbox
        [nzChecked]="
          form.get('caseBehaviorConsequenceIds')?.value?.includes(con.id)
        "
        (nzCheckedChange)="
          onCheckboxChange('caseBehaviorConsequenceIds', $event, con.id);
          onConsequenceChange($event, con)
        "
        [nzValue]="con.id">
        {{ con.name }}
      </span>
    </div>
    <div
      class="ant-form-item-explain-error mt-3"
      *ngIf="form.get('caseBehaviorConsequenceIds')?.hasError('required')">
      Please select at least 1 consequence.
    </div>
  </nz-form-item>
  <ng-container formArrayName="caseBehaviorConsequenceDescription">
    <nz-divider *ngIf="consequenceDescriptionControls.length > 0" />
    <ng-container
      *ngFor="
        let ctrl of consequenceDescriptionControls;
        let i = index;
        trackBy: trackByIndex
      "
      [formGroup]="ctrl">
      <nz-form-item>
        <nz-form-label
          [nzFor]="'consequence-description-' + i"
          [nzRequired]="true">
          {{ getBehaviorConsequenceTitle(ctrl.value.behaviorConsequenceId) }}
        </nz-form-label>
        <nz-form-control>
          <textarea
            [id]="'consequence-description-' + i"
            name="description"
            [attr.aria-label]="
              getBehaviorConsequenceTitle(ctrl.value.behaviorConsequenceId)
            "
            formControlName="description"
            rows="4"
            nz-input
            placeholder="Enter description"
            (input)="
              onControlInputChange($event, ctrl.get('description'))
            "></textarea>
          <div class="mt-3 remaining-text">
            {{ ctrl.value.description.length }} of 4000 characters used
          </div>
          <div
            class="ant-form-item-explain-error mt-3"
            *ngIf="ctrl.get('description')?.errors?.['required']">
            Please enter your description.
          </div>
        </nz-form-control>
      </nz-form-item>
    </ng-container>
  </ng-container>
</ng-container>
